function toHex(n: string) {
  let number = parseInt(n, 10);
  if (isNaN(number)) return '00';
  number = Math.max(0, Math.min(number, 255));
  return (
    '0123456789ABCDEF'.charAt((number - (number % 16)) / 16) +
    '0123456789ABCDEF'.charAt(number % 16)
  );
}

function rgbToHex(R: string, G: string, B: string) {
  return '#' + toHex(R) + toHex(G) + toHex(B);
}

//input rbgString of (css) form `rgb(255,255,255)`
export const getHexVal = (rbgString: string) => {
  const rgbArr = rbgString.split('(')[1].split(')')[0].split(',');
  return rgbToHex(rgbArr[0], rgbArr[1], rgbArr[2]);
};
